module.exports = __webpack_public_path__ + "img/broadband.b21cf90.png";